export default __webpack_public_path__ + "static/media/audioFileIcon.69642b0d.svg";